export default __webpack_public_path__ + "static/media/ArrowRed.61a264ae.svg";